import { create } from "zustand"
import { MensajeError } from "../FuncionesLocales";
import { _Componentes_WebApiCalls_Post } from "../../ComponentesGlobales/WebApiCalls";
import { useStoreHome } from "../../paginas/Home/useStoreHome";

export const useStoreTrazabilidad = create((set, get) => {
    return {
        Lectura: '',
        Leyendo: false,
        Datos: null,
        clavesOcultas: ["Unidades","Pedido","Despacho","OperadorNombre","OperadorApellido","OperadorLogin","Pallet"
            ,"MercaderiaCodigo","EnvaseSecundarioPeso","OperadorLogin","EnvaseSecundarioCodigo","EnvaseSecundario",
            "Remito","Deposito","Estanteria","Posicion ","Congelado","Temperatura","ContramarcaCodigo","ContramarcaDescripcion",
            "Posicion","LoteEntrada"],
        getTrazabilidad: async (Lectura) => {
            if (!useStoreHome.getState().EmpresaId || get().Leyendo || !Lectura) { return; }
            const sParametros = { EmpresaId: useStoreHome.getState().EmpresaId, Lectura:  Lectura };
            set({ Leyendo: true });
            try {
                const data = await _Componentes_WebApiCalls_Post("PISeunTrazabilidad/GetTrazabilidad", sParametros);
                if (data.error) {
                    MensajeError(data.error);
                } else {
                    set({ Datos: data.data });
                }
            }
            catch (error) {
                MensajeError(data.error);
            } finally {

            }
            set({ Leyendo: false });

        },

    }
})